import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  BookmarkIcon, BookmarkFillIcon, ShareIcon, CheckIcon,
  MapPinIcon, StarIcon, PackageIcon, ClockIcon, AlertIcon,
  ListIcon, VerifiedIcon, MessageIcon, ShieldIcon,
} from '../../components/Icons';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function DetalhesProduto() {
  const navigate      = useNavigate();
  const { id }        = useParams();
  const { utilizador } = useAuth();
  const kycVerificado  = utilizador?.kyc_estado === 'verificado';
  const [anuncio,     setAnuncio]    = useState(null);
  const [avaliacoes,  setAvaliacoes] = useState([]);
  const [carregando,  setCarregando] = useState(true);
  const [erro,        setErro]       = useState('');
  const [activeThumb, setThumb]      = useState(0);
  const [dataInicio,  setDataInicio] = useState('');
  const [dataFim,     setDataFim]    = useState('');
  const [isFav,       setIsFav]      = useState(false);
  const [toastMsg,    setToastMsg]   = useState('');
  const [contactOpen, setContactOpen] = useState(false);
  const [modoCompra, setModoCompra] = useState(false);

  const dias       = dataInicio && dataFim
    ? Math.max(1, Math.ceil((new Date(dataFim) - new Date(dataInicio)) / (1000*60*60*24)))
    : 1;
  const precoDia   = parseFloat(anuncio?.preco_dia || 0);
  const caucao     = parseFloat(anuncio?.caucao    || 0);
  const aluguer    = precoDia * dias;
  const totalPagar = aluguer + caucao; // cliente não paga comissão
  const precoVenda   = parseFloat(anuncio?.preco_venda || 0);
  const totalCompra  = precoVenda; // cliente não paga comissão

  useEffect(() => {
    const amanha = new Date(); amanha.setDate(amanha.getDate()+1);
    const depois  = new Date(); depois.setDate(depois.getDate()+2);
    setDataInicio(amanha.toISOString().split('T')[0]);
    setDataFim(depois.toISOString().split('T')[0]);
    carregarAnuncio();
    verificarFavorito();
  }, [id]);

  const carregarAnuncio = async () => {
    setCarregando(true);
    try {
      const res  = await fetch(`${BASE}/anuncios/${id}`);
      const data = await res.json();
      if (!data.sucesso) throw new Error(data.mensagem || 'Não encontrado');
      setAnuncio(data.anuncio);
      setAvaliacoes(data.avaliacoes || []);
    } catch(err) { setErro(err.message); }
    finally { setCarregando(false); }
  };

  const verificarFavorito = async () => {
    if (!token()) return;
    try {
      const res  = await fetch(`${BASE}/favoritos`, { headers: { Authorization: `Bearer ${token()}` } });
      const data = await res.json();
      if (data.sucesso) setIsFav(data.favoritos.some(f => f.anuncio_id === id));
    } catch {}
  };

  const toggleFavorito = async () => {
    if (!token()) { navigate('/login'); return; }
    try {
      const res  = await fetch(`${BASE}/favoritos/${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      if (data.sucesso) {
        setIsFav(data.favorito);
        toast(data.favorito ? 'Adicionado aos favoritos' : 'Removido dos favoritos');
      }
    } catch {}
  };

  const partilhar = () => {
    if (navigator.share) {
      navigator.share({ title: anuncio?.titulo, url: window.location.href }).catch(() => {});
    } else {
      navigator.clipboard?.writeText(window.location.href);
      toast('Link copiado para a área de transferência');
    }
  };

  const toast = (msg) => {
    setToastMsg(msg);
    setTimeout(() => setToastMsg(''), 2500);
  };

  const reservar = () => {
    if (!anuncio) return;
    sessionStorage.setItem('kialuga_checkout', JSON.stringify({
      anuncio_id:    anuncio.id,
      titulo:        anuncio.titulo,
      preco_dia:     anuncio.preco_dia,
      caucao:        anuncio.caucao,
      fotos:         anuncio.fotos,
      localizacao:   anuncio.localizacao,
      opcao_entrega: anuncio.opcao_entrega,
      fornecedor_nome: anuncio.fornecedor_nome,
      fornecedor_foto: anuncio.fornecedor_foto,
      data_inicio:   dataInicio,
      data_fim:      dataFim,
      dias,
      valor_aluguer: aluguer,
      valor_caucao:  caucao,
      valor_total:   totalPagar,
    }));
    navigate('/cliente/checkout');
  };

  const comprar = () => {
    if (!anuncio) return;
    sessionStorage.setItem('kialuga_checkout', JSON.stringify({
      tipo:          'compra',
      anuncio_id:    anuncio.id,
      titulo:        anuncio.titulo,
      preco_venda:   anuncio.preco_venda,
      fotos:         anuncio.fotos,
      localizacao:   anuncio.localizacao,
      opcao_entrega: anuncio.opcao_entrega,
      fornecedor_nome: anuncio.fornecedor_nome,
      fornecedor_foto: anuncio.fornecedor_foto,
      data_inicio:   new Date().toISOString().split('T')[0],
      data_fim:      new Date().toISOString().split('T')[0],
      dias:          1,
      valor_aluguer: precoVenda,
      valor_caucao:  0,
      valor_total:   totalCompra,
    }));
    navigate('/cliente/checkout');
  };

  if (carregando) return (
    <>
      <div className="topbar">
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <button className="btn btn-ghost btn-sm" onClick={()=>navigate('/cliente')}>← Voltar</button>
          <div className="topbar-title">A carregar...</div>
        </div>
      </div>
      <div className="page-content" style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'300px'}}>
        <div style={{textAlign:'center',color:'var(--text-muted)'}}>
          <ClockIcon size={40} color='var(--border)'/>
          <div style={{marginTop:'12px'}}>A carregar produto...</div>
        </div>
      </div>
    </>
  );

  if (erro || !anuncio) return (
    <>
      <div className="topbar">
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <button className="btn btn-ghost btn-sm" onClick={()=>navigate('/cliente')}>← Voltar</button>
          <div className="topbar-title">Produto não encontrado</div>
        </div>
      </div>
      <div className="page-content" style={{textAlign:'center',padding:'60px'}}>
        <AlertIcon size={48} color='var(--text-muted)'/>
        <div style={{fontSize:'16px',fontWeight:'600',marginBottom:'20px',marginTop:'12px'}}>{erro || 'Produto não encontrado'}</div>
        <button className="btn btn-primary" onClick={()=>navigate('/cliente')}>← Voltar</button>
      </div>
    </>
  );

  const fotos     = (anuncio.fotos || []).filter(f=>f);
  const fotoActiva= fotos[activeThumb] || null;

  return (
    <>
      {/* Toast */}
      {toastMsg && (
        <div style={{position:'fixed',bottom:'24px',left:'50%',transform:'translateX(-50%)',background:'var(--brand-dark)',color:'#fff',padding:'10px 20px',borderRadius:'20px',fontSize:'13px',fontWeight:'500',zIndex:9999,boxShadow:'0 4px 20px rgba(0,0,0,0.3)'}}>
          {toastMsg}
        </div>
      )}

      {/* Modal Contactar Fornecedor */}
      {contactOpen && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}
          onClick={() => setContactOpen(false)}>
          <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'380px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}
            onClick={e => e.stopPropagation()}>
            <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'20px'}}>
              <div style={{width:'44px',height:'44px',borderRadius:'50%',overflow:'hidden',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',fontWeight:'700',color:'#fff',flexShrink:0}}>
                {anuncio.fornecedor_foto
                  ? <img src={anuncio.fornecedor_foto} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                  : (anuncio.fornecedor_nome||'?')[0].toUpperCase()
                }
              </div>
              <div>
                <div style={{fontSize:'14px',fontWeight:'600'}}>{anuncio.fornecedor_nome||'Fornecedor'}</div>
                <div style={{fontSize:'11px',color:'var(--text-muted)'}}>Fornecedor · {anuncio.localizacao||'Angola'}</div>
              </div>
              <button onClick={() => setContactOpen(false)} style={{marginLeft:'auto',background:'transparent',border:'none',cursor:'pointer',color:'var(--text-muted)',fontSize:'18px',lineHeight:1}}>×</button>
            </div>

            <div style={{fontSize:'13px',color:'var(--text-secondary)',marginBottom:'16px',lineHeight:'1.5'}}>
              Para mais informações sobre o anúncio <strong>"{anuncio.titulo}"</strong>, podes contactar o fornecedor diretamente:
            </div>

            {anuncio.fornecedor_telefone ? (
              <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                <a href={`https://wa.me/${(anuncio.fornecedor_telefone||'').replace(/\D/g,'')}`}
                  target="_blank" rel="noopener noreferrer"
                  style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',padding:'12px',background:'#25D366',color:'#fff',borderRadius:'10px',textDecoration:'none',fontSize:'13px',fontWeight:'600'}}>
                  WhatsApp — {anuncio.fornecedor_telefone}
                </a>
                <a href={`tel:${anuncio.fornecedor_telefone}`}
                  style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',padding:'10px',background:'var(--surface)',color:'var(--text-primary)',borderRadius:'10px',textDecoration:'none',fontSize:'13px',fontWeight:'500',border:'1px solid var(--border)'}}>
                  Ligar — {anuncio.fornecedor_telefone}
                </a>
              </div>
            ) : (
              <div style={{textAlign:'center',padding:'20px',background:'var(--surface)',borderRadius:'10px',fontSize:'13px',color:'var(--text-muted)'}}>
                Contacto não disponível publicamente.<br/>
                <span style={{fontSize:'12px'}}>Faz uma reserva para receber os dados de contacto.</span>
              </div>
            )}

            <div style={{fontSize:'11px',color:'var(--text-muted)',textAlign:'center',marginTop:'14px'}}>
              Menciona o anúncio ao contactar para facilitar a comunicação.
            </div>
          </div>
        </div>
      )}

      <div className="topbar">
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <button className="btn btn-ghost btn-sm" onClick={()=>navigate('/cliente')} style={{padding:'6px 10px'}}>← Voltar</button>
          <div>
            <div className="topbar-title" style={{maxWidth:'320px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{anuncio.titulo}</div>
            <div className="topbar-sub">{anuncio.categoria_icone} {anuncio.categoria_nome} · {anuncio.localizacao || 'Luanda'}</div>
          </div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={toggleFavorito} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            {isFav
              ? <><BookmarkFillIcon size={14} color='var(--orange)'/> Guardado</>
              : <><BookmarkIcon size={14}/> Guardar</>
            }
          </button>
          <button className="btn btn-outline" onClick={partilhar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <ShareIcon size={14}/> Partilhar
          </button>
        </div>
      </div>

      <div className="page-content">
        <div className="product-detail-grid">

          {/* Esquerda */}
          <div>
            {/* Galeria */}
            <div className="card" style={{padding:0,overflow:'hidden',marginBottom:'14px'}}>
              <div style={{height:'280px',background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center',overflow:'hidden',position:'relative'}}>
                {fotoActiva
                  ? <img src={fotoActiva} alt={anuncio.titulo} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                  : <PackageIcon size={80} color='rgba(249,115,22,0.3)'/>
                }
              </div>
              {fotos.length > 1 && (
                <div style={{display:'flex',gap:'8px',padding:'12px',overflowX:'auto'}}>
                  {fotos.map((f,i)=>(
                    <div key={i} onClick={()=>setThumb(i)} style={{width:'60px',height:'60px',borderRadius:'8px',overflow:'hidden',flexShrink:0,cursor:'pointer',border:activeThumb===i?'2.5px solid var(--orange)':'2px solid transparent',background:'linear-gradient(135deg,#fde8d8,#fed7b0)'}}>
                      <img src={f} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Descrição */}
            <div className="card" style={{marginBottom:'14px'}}>
              <div style={{fontSize:'14px',fontWeight:'600',marginBottom:'10px'}}>Descrição</div>
              <div style={{display:'inline-flex',alignItems:'center',gap:'5px',fontSize:'11px',color:'var(--success)',background:'var(--success-bg)',padding:'4px 10px',borderRadius:'6px',marginBottom:'12px'}}>
                <CheckIcon size={11} color='var(--success)'/> Produto verificado pela KiAluga
              </div>
              <div style={{fontSize:'13px',color:'var(--text-secondary)',lineHeight:'1.7',marginBottom:'12px',whiteSpace:'pre-line'}}>
                {anuncio.descricao || 'Sem descrição disponível.'}
              </div>
              {anuncio.regras && (
                <div style={{background:'var(--surface)',borderRadius:'8px',padding:'10px 14px',marginBottom:'12px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px',fontWeight:'600',marginBottom:'6px'}}>
                    <ListIcon size={13} color='var(--text-secondary)'/> Regras
                  </div>
                  <div style={{fontSize:'12px',color:'var(--text-secondary)',lineHeight:'1.6',whiteSpace:'pre-line'}}>{anuncio.regras}</div>
                </div>
              )}
              <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'14px'}}>
                {anuncio.estado_bem && (
                  <span style={{fontSize:'11px',background:'var(--surface)',color:'var(--text-secondary)',padding:'3px 9px',borderRadius:'6px',border:'1px solid var(--border)'}}>
                    Estado: {anuncio.estado_bem==='excelente'?'Excelente':anuncio.estado_bem==='muito_bom'?'Muito bom':'Bom'}
                  </span>
                )}
                {anuncio.localizacao && (
                  <span style={{fontSize:'11px',background:'var(--surface)',color:'var(--text-secondary)',padding:'3px 9px',borderRadius:'6px',border:'1px solid var(--border)',display:'inline-flex',alignItems:'center',gap:'4px'}}>
                    <MapPinIcon size={10}/> {anuncio.localizacao}
                  </span>
                )}
              </div>

              {/* Fornecedor */}
              <div style={{display:'flex',alignItems:'center',gap:'10px',paddingTop:'12px',borderTop:'1px solid var(--border)'}}>
                {anuncio.fornecedor_foto
                  ? <img src={anuncio.fornecedor_foto} alt="" style={{width:'36px',height:'36px',borderRadius:'50%',objectFit:'cover',flexShrink:0}} onError={e=>e.target.style.display='none'} />
                  : <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',fontWeight:'700',color:'#fff',flexShrink:0}}>
                      {(anuncio.fornecedor_nome||'?')[0].toUpperCase()}
                    </div>
                }
                <div style={{flex:1}}>
                  <div style={{fontSize:'13px',fontWeight:'500'}}>{anuncio.fornecedor_nome||'Fornecedor'}</div>
                  <div style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'11px',color:'var(--text-muted)'}}>
                    {anuncio.fornecedor_kyc==='verificado' && (
                      <span style={{display:'flex',alignItems:'center',gap:'3px',color:'var(--success)'}}>
                        <VerifiedIcon size={11} color='var(--success)'/> Verificado ·
                      </span>
                    )}
                    <StarIcon size={11} color='#f59e0b'/> {parseFloat(anuncio.fornecedor_rating||0).toFixed(1)} · {anuncio.fornecedor_avaliacoes||0} avaliações
                  </div>
                </div>
                <button className="btn btn-ghost btn-sm" style={{display:'flex',alignItems:'center',gap:'5px'}}
                  onClick={() => setContactOpen(true)}>
                  <MessageIcon size={12}/> Contactar
                </button>
              </div>
            </div>

            {/* Avaliações */}
            {avaliacoes.length > 0 && (
              <div className="card">
                <div style={{fontSize:'14px',fontWeight:'600',marginBottom:'14px'}}>Avaliações ({avaliacoes.length})</div>
                {avaliacoes.map((av,i)=>(
                  <div key={i} style={{paddingBottom:i<avaliacoes.length-1?'12px':0,borderBottom:i<avaliacoes.length-1?'1px solid var(--border)':0,marginBottom:i<avaliacoes.length-1?'12px':0}}>
                    <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'4px'}}>
                      <div style={{width:'26px',height:'26px',borderRadius:'50%',background:'var(--orange-light)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'10px',fontWeight:'600',color:'var(--orange-dark)'}}>{(av.avaliador_nome||'?')[0]}</div>
                      <span style={{fontSize:'12px',fontWeight:'500'}}>{av.avaliador_nome}</span>
                      <span style={{display:'flex',gap:'2px'}}>
                        {[1,2,3,4,5].map(s=><StarIcon key={s} size={11} color={s<=av.nota?'#f59e0b':'var(--border)'}/>)}
                      </span>
                      <span style={{fontSize:'11px',color:'var(--text-muted)',marginLeft:'auto'}}>{new Date(av.created_at).toLocaleDateString('pt-PT')}</span>
                    </div>
                    {av.comentario && <div style={{fontSize:'12px',color:'var(--text-secondary)',marginLeft:'34px'}}>{av.comentario}</div>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Booking card */}
          <div style={{position:'sticky',top:'80px'}}>
            <div style={{background:'var(--card)',border:'2px solid var(--orange)',borderRadius:'var(--radius-lg)',padding:'18px',marginBottom:'12px'}}>
              <div style={{fontSize:'16px',fontWeight:'700',marginBottom:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{anuncio.titulo}</div>
              <div style={{fontSize:'12px',color:'var(--text-muted)',marginBottom:'14px'}}>
                {anuncio.categoria_icone} {anuncio.categoria_nome}
                {anuncio.rating_medio>0 && (
                  <span style={{display:'inline-flex',alignItems:'center',gap:'3px',marginLeft:'6px'}}>
                    · <StarIcon size={10} color='#f59e0b'/> {parseFloat(anuncio.rating_medio).toFixed(1)}
                  </span>
                )}
              </div>
              {anuncio.disponivel_venda && (
                <div style={{display:'flex',gap:'0',marginBottom:'16px',background:'var(--surface)',borderRadius:'10px',padding:'3px'}}>
                  <button
                    onClick={()=>setModoCompra(false)}
                    style={{
                      flex:1,padding:'7px',borderRadius:'8px',border:'none',cursor:'pointer',
                      background:!modoCompra?'var(--card)':'transparent',
                      color:!modoCompra?'var(--text-primary)':'var(--text-muted)',
                      fontWeight:!modoCompra?'700':'500',fontSize:'12px',fontFamily:'inherit',
                      boxShadow:!modoCompra?'var(--shadow-sm)':'none',transition:'all 0.15s',
                    }}
                  >
                    🔄 Alugar
                  </button>
                  <button
                    onClick={()=>setModoCompra(true)}
                    style={{
                      flex:1,padding:'7px',borderRadius:'8px',border:'none',cursor:'pointer',
                      background:modoCompra?'var(--card)':'transparent',
                      color:modoCompra?'var(--success)':'var(--text-muted)',
                      fontWeight:modoCompra?'700':'500',fontSize:'12px',fontFamily:'inherit',
                      boxShadow:modoCompra?'var(--shadow-sm)':'none',transition:'all 0.15s',
                    }}
                  >
                    🛒 Comprar
                  </button>
                </div>
              )}

              <div style={{display:'flex',alignItems:'baseline',gap:'6px',marginBottom:'16px'}}>
                {modoCompra ? (
                  <>
                    <span style={{fontSize:'26px',fontWeight:'700',color:'var(--success)'}}>{precoVenda.toLocaleString()} Kz</span>
                    <span style={{fontSize:'13px',color:'var(--text-muted)'}}>preço de compra</span>
                  </>
                ) : (
                  <>
                    <span style={{fontSize:'26px',fontWeight:'700',color:'var(--orange)'}}>{precoDia.toLocaleString()} Kz</span>
                    <span style={{fontSize:'13px',color:'var(--text-muted)'}}>/ dia</span>
                  </>
                )}
              </div>

              {modoCompra ? (
                <div style={{background:'var(--surface)',borderRadius:'8px',padding:'10px 12px',marginBottom:'12px'}}>
                  {[
                    ['Preço de compra', `${precoVenda.toLocaleString()} Kz`],
                  ].map(([l,v])=>(
                    <div key={l} style={{display:'flex',justifyContent:'space-between',fontSize:'12px',padding:'3px 0'}}>
                      <span style={{color:'var(--text-secondary)'}}>{l}</span><span>{v}</span>
                    </div>
                  ))}
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:'13px',fontWeight:'600',paddingTop:'8px',borderTop:'1px solid var(--border)',marginTop:'5px'}}>
                    <span>Total a pagar</span><span style={{color:'var(--success)'}}>{totalCompra.toLocaleString()} Kz</span>
                  </div>
                </div>
              ) : (
                <>
                  {/* Datas */}
                  <div className="grid-2" style={{marginBottom:'14px'}}>
                    {[['Data início',dataInicio,setDataInicio,new Date().toISOString().split('T')[0]],['Data fim',dataFim,setDataFim,dataInicio]].map(([lbl,val,setter,minVal])=>(
                      <div key={lbl}>
                        <div style={{fontSize:'11px',fontWeight:'500',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'4px'}}>{lbl}</div>
                        <input type="date" value={val} min={minVal} onChange={e=>setter(e.target.value)}
                          style={{width:'100%',padding:'8px 10px',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'12px',fontFamily:'inherit',outline:'none',color:'var(--text-primary)',background:'var(--card)'}} />
                      </div>
                    ))}
                  </div>

                  {/* Resumo */}
                  <div style={{background:'var(--surface)',borderRadius:'8px',padding:'10px 12px',marginBottom:'12px'}}>
                    {[
                      [`${precoDia.toLocaleString()} Kz × ${dias} dia${dias>1?'s':''}`,`${aluguer.toLocaleString()} Kz`],
                      ['Caução (reembolsável)',`${caucao.toLocaleString()} Kz`],
                    ].map(([l,v])=>(
                      <div key={l} style={{display:'flex',justifyContent:'space-between',fontSize:'12px',padding:'3px 0'}}>
                        <span style={{color:'var(--text-secondary)'}}>{l}</span><span>{v}</span>
                      </div>
                    ))}
                    <div style={{display:'flex',justifyContent:'space-between',fontSize:'13px',fontWeight:'600',paddingTop:'8px',borderTop:'1px solid var(--border)',marginTop:'5px'}}>
                      <span>Total a pagar</span><span>{totalPagar.toLocaleString()} Kz</span>
                    </div>
                  </div>
                </>
              )}

              <div style={{display:'flex',gap:'8px',background:'var(--info-bg)',border:'1px solid #bfdbfe',borderRadius:'8px',padding:'9px 11px',marginBottom:'12px',fontSize:'11px',color:'var(--info)',alignItems:'flex-start'}}>
                <CheckIcon size={13} color='var(--info)' style={{flexShrink:0,marginTop:'1px'}}/>
                <div>Pagamento protegido por escrow. Caução devolvida após devolução sem problemas.</div>
              </div>

              {!kycVerificado ? (
                <div style={{borderRadius:'10px',overflow:'hidden'}}>
                  <div style={{background:'var(--warning-bg)',border:'1px solid var(--warning-border)',borderRadius:'10px',padding:'12px 14px',display:'flex',gap:'10px',alignItems:'flex-start',marginBottom:'8px'}}>
                    <ShieldIcon size={16} color='var(--warning)' style={{flexShrink:0,marginTop:'1px'}}/>
                    <div>
                      <div style={{fontSize:'13px',fontWeight:'700',color:'var(--warning)',marginBottom:'2px'}}>Verificação de identidade necessária</div>
                      <div style={{fontSize:'12px',color:'var(--text-secondary)',lineHeight:'1.5'}}>
                        Para reservar precisas de verificar a tua identidade. Acede ao teu perfil e submete o BI e uma selfie.
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline" style={{width:'100%',justifyContent:'center',padding:'11px',fontSize:'13px'}}
                    onClick={()=>navigate('/perfil')}>
                    Verificar identidade →
                  </button>
                </div>
              ) : modoCompra ? (
                <button className="btn" style={{width:'100%',justifyContent:'center',padding:'12px',fontSize:'14px',background:'var(--success)',color:'#fff',border:'none',cursor:'pointer',fontFamily:'inherit',fontWeight:'700',borderRadius:'8px',display:'flex',alignItems:'center',gap:'8px'}}
                  onClick={comprar}>
                  🛒 Comprar agora → {totalCompra.toLocaleString()} Kz
                </button>
              ) : (
                <button className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'12px',fontSize:'14px'}} onClick={reservar} disabled={!dataInicio||!dataFim}>
                  Reservar agora →
                </button>
              )}
              {kycVerificado && (
                <div style={{textAlign:'center',fontSize:'11px',color:'var(--text-muted)',marginTop:'8px'}}>
                  {modoCompra ? 'Compra protegida pela KiAluga. Pagamento seguro.' : 'Sem compromisso até confirmar o pagamento'}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
